import axiosInstance from "./axiosInstance";
import {
    BILLING_STATUS_API,
    BILLING_CREATE_API,
    BILLING_CANCEL_API,
    CHECK_SHOP_API,
    RECOMMENDATIONS_API,
    RECOMMENDATION_STATS_API,
    PRODUCTS_SYNC_API,
    AI_SUGGESTIONS_PROGRESS_API,
    FETCH_PRODUCTS_API,
    FETCH_AI_SUGGESTIONS_API,
    BULK_CREATE_RECOMMENDATIONS_API,
    CREATE_RECOMMENDATION_API, AUTH_CHECK_API,
} from '../constants/apiUrls';

export const checkBillingStatusAPI = (shop: string | null) => {
    return axiosInstance.get(BILLING_STATUS_API, {params: {shop}});
};

export const createBillingAPI = (shop: string | null, host: string) => {
    return axiosInstance.get(BILLING_CREATE_API, {params: {shop, host}});
};

export const cancelBillingAPI = (shop: string | null) => {
    return axiosInstance.post(BILLING_CANCEL_API, {shop});
};

export const authCheckAPI = (shop: string | null) => {
    return axiosInstance.get(AUTH_CHECK_API, {params: {shop}, withCredentials: true});
};

export const checkShopAPI = (shop: string | null) => {
    return axiosInstance.get(CHECK_SHOP_API, {params: {shop}, withCredentials: true});
};

export const fetchRecommendationsAPI = (shop: string | null, page: number, debouncedSearch?: string) => {
    return axiosInstance.get(RECOMMENDATIONS_API, {
        params: {shop, page, search: debouncedSearch || undefined},
    })
}

export const deleteRecommendationAPI = (id: number) => {
    return axiosInstance.delete(`${RECOMMENDATIONS_API}/${id}`);
};

export const toggleRecommendationAPI = (id: number, shop: string | null, enabled: boolean) => {
    return axiosInstance.patch(`${RECOMMENDATIONS_API}/${id}/toggle`, {shop, enabled});
};

export const fetchRecommendationStatsAPI = (shop: string | null) => {
    return axiosInstance.get(RECOMMENDATION_STATS_API, {params: {shop}})
}

export const productsSyncAPI = (shop: string | null) => {
    return axiosInstance.post(PRODUCTS_SYNC_API, {shop})
}

export const fetchProductsAPI = (shop: string | null, search: string) => {
    return axiosInstance.get(FETCH_PRODUCTS_API, {
        params: { shop, search: search || undefined },
    });
};

export const fetchAISuggestionsAPI = (shop: string | null, productId: string) => {
    return axiosInstance.get(FETCH_AI_SUGGESTIONS_API, {
        params: { shop, product_id: productId },
    });
};

export const bulkCreateRecommendationsAPI = (
    shop: string | null,
    productId: number,
    recommendedProductIds: number[],
    algo: 'manual' | 'ai'
) => {
    return axiosInstance.post(BULK_CREATE_RECOMMENDATIONS_API, {
        shop,
        product_id: productId,
        recommended_product_ids: recommendedProductIds,
        algo,
    });
};

export const fetchAISuggestionsProgressAPI = (shop: string | null) => {
    return axiosInstance.get(AI_SUGGESTIONS_PROGRESS_API, {params: {shop}})
}

export const createRecommendationAPI = (
    shop: string | null,
    productId: number,
    recommendedProductId: number
) => {
    return axiosInstance.post(CREATE_RECOMMENDATION_API, {
        shop,
        product_id: productId,
        recommended_product_id: recommendedProductId,
        algo: 'manual',
        enabled: true,
    });
};

export const editRecommendationAPI = (
    id: number,
    shop: string | null,
    productId: number,
    recommendedProductId: number
) => {
    return axiosInstance.patch(`${RECOMMENDATIONS_API}/${id}`, {
        shop,
        product_id: productId,
        recommended_product_id: recommendedProductId,
        algo: 'manual',
        enabled: true,
    });
};
